<template>
    <div v-if="widgetReady">
        <div class="table-container">
            <div>
                <table class="table table-sm" style="margin-bottom: 0px;">
                    <thead>
                        <th>
                            <span>Relationship</span>
                        </th>
                        <th>
                            <span>Plan Category</span>
                        </th>
                        <th>
                            <span>Age Band</span>
                        </th>
                        <th>
                            <span>Base Plan Price</span>
                        </th>
                        <th v-for="(f, index) in priceTiers[0].fees" :key="index">
                            <span>{{ f.feeName }} </span>
                        </th>
                        <th>
                            <span>Total Price</span>
                        </th>
                        <th>
                            <span></span>
                        </th>
                    </thead>
                    <tbody>
                        <template>
                            <tr v-for="(p, index) in priceTiers" :key="index">
                                <td>
                                    {{ p.relationship }}
                                </td>
                                <td>
                                    {{ planCategoryDescription }}
                                </td>
                                <td>
                                    {{p.minAge}} - {{p.maxAge}}
                                </td>
                                <td>
                                    {{ p.price | currency }}
                                </td>
                                <td v-for="(f, fIndex) in p.fees" :key="fIndex">
                                    {{ p.fees[fIndex].amount | currency }}
                                </td>
                                <td>
                                    {{ p.totalWithFees | currency }}
                                </td>
                                <td class="tier-button-content">
                                    <div class="future-settings-container" v-if="Boolean(p.futureSettings)">
                                        <div class="pending-link">
                                            <!-- <div class="future-price-tier">
                                                <future-price-tier :future-settings="viewFuturePriceTier(p)"></future-price-tier>
                                            </div> -->
                                            <span class="label label-warning">Pending Change</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <br>
            <div>
                <div class="alert alert-warning margin-top-15">
                    <p>
                        Plan price proration, discounts and Accresa transaction fees apply separately and are not included in the totals above.
                    </p>
                </div>
            </div>
            <div class="margin-top-15" v-if="futureOnlyPriceTiers.length > 0">
                <div v-for="future in futureOnlyPriceTiers">
                    <div class="alert alert-info">
                        New Price Tier: Begins on {{ future.effectiveDate | shortDate }}
                        with an age range of {{ future.minAge }}-{{ future.maxAge }}
                        at {{ future.price | currency }}
                    </div>
                </div>
            </div>
            <div class="margin-top-15" v-if="deletedOnlyPriceTiers.length > 0">
                <div v-for="deleted in deletedOnlyPriceTiers">
                    <div class="alert alert-info">
                        Deleted Price Tier: Ends on {{ deleted.endDate | shortDate }}
                        with an age range of {{ deleted.minAge }}-{{ deleted.maxAge }}
                        at {{ deleted.price | currency }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {api} from "../../../../../global/framework/api.js";
    import {notifications} from "../../../../../global/notifications.js";
    import {common} from "../../../../../global/common.js";
    import {formatter} from "../../../../../global/formatter.js";
    import FuturePriceTier from "./FuturePriceTier.vue";

    export default {
        name: "PriceTiersSummary",
        components: {FuturePriceTier},
        props: {
            planId: {type: [Number], required: true},
            companyId: {type: [Number], required: true},
        },
        data() {
            return {
                priceTiers: [],
                futureOnlyPriceTiers: [],
                deletedOnlyPriceTiers: [],
                futureSettings: {},
                widgetReady: false,
                planCategoryDescription: "",
            }
        },
        methods: {
            viewFuturePriceTier(priceTier) {
                let futureSettings = {...priceTier.futureSettings, effectiveDate: priceTier.futureSettings.effectiveDate};
                return futureSettings;
            },
            relationshipMethod(obj) {
                return common.RELATIONSHIP_TYPE[obj];
            },
        },
        async mounted() {
            let data = await api.getDataWithTwoIds('PriceTier', this.planId, 'PriceTierSummary', this.companyId);
            this.planCategoryDescription = data.planCategoryDescription || "";
            var currentPriceTiers = data.current;
            var futureOnly = data.futureOnly;
            var deleteOnly = data.deletedOnly;

            Object.keys(currentPriceTiers).forEach(key => {
                let p = data.current[key];
                p.relationship = this.relationshipMethod(p.consumerRelationshipId);
                this.priceTiers.push(p);
            })

            for(let pt of deleteOnly){
                this.deletedOnlyPriceTiers.push(pt);
            }

            for(let pt of futureOnly){
                this.futureOnlyPriceTiers.push(pt);
            }

            //sorted by primary to dependent
            this.priceTiers.sort(function(a, b) { return a.consumerRelationshipId - b.consumerRelationshipId;});         
            this.widgetReady = true;
        },
    }
</script>

<style scoped>

</style>